module.exports = __webpack_public_path__ + "img/ic_done_green.499b3e9d.png";